import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import Button from '../Button';
import styled from "styled-components";


const ConfirmationDialog = ({ title, header, body, cancelButton, acceptButton, onClose, viewOnly}) => {
    return (
        <div className="confirmation">
            <div className="confirmation--toolbar">
                <div className="confirmation--title">{title}</div>
                <div className="confirmation--close"><FontAwesomeIcon icon={faTimes} size="lg" onClick={onClose}/></div>
            </div>
            <div className="confirmation--header">
                {header}
            </div>
            <div className="confirmation--body" style={{padding: 16}}>
                {body}
            </div>
            <div className="confirmation--footer">
                <div className="confirmation--footer-left">
                    <Button id="acceptButton" onClickHandler={cancelButton.action}>{cancelButton.label}</Button>
                </div>

                {!viewOnly &&
                <div className="confirmation--footer-right">
                    <Button id="cancelButton" onClickHandler={acceptButton.action}>{acceptButton.label}</Button>
                </div>
                }
            </div>
        </div>
    )
};

export default ConfirmationDialog;